import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ld-profile-settings-skeleton',
  template: `
    <div id="profile-settings-skeleton" class="flex flex-col gap-6 animate-pulse">
      <!-- Loan Card Skeleton -->
      <div class="bg-white rounded-3xl border border-ld-border overflow-hidden">
        <!-- Description Section with Edit Profile Link -->
        <div class="px-4 sm:px-8 py-4 sm:py-6 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
          <div class="flex-1 space-y-2">
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-3/4 bg-gray-200 rounded"></div>
          </div>
          <div class="h-5 w-20 bg-purple-100 rounded shrink-0"></div>
        </div>

        <div class="px-4 sm:px-8 pb-6 sm:pb-8 space-y-6 sm:space-y-8">
          <!-- Email Section -->
          <div>
            <div class="h-6 w-32 bg-purple-100 rounded mb-4"></div>
            <div class="max-w-sm">
              <div class="h-14 w-full bg-gray-200 rounded-lg"></div>
              <div class="h-3 w-64 bg-gray-200 rounded mt-2"></div>
            </div>
          </div>

          <!-- Phone Numbers Section -->
          <div>
            <div class="h-6 w-36 bg-purple-100 rounded mb-2"></div>
            <div class="h-4 w-96 bg-gray-200 rounded mb-4"></div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
              <div class="flex flex-col gap-4">
                <div class="h-14 w-full bg-gray-200 rounded-lg"></div>
                <div class="flex items-center gap-2">
                  <div class="w-5 h-5 rounded-full bg-gray-200"></div>
                  <div class="h-4 w-28 bg-gray-200 rounded"></div>
                </div>
              </div>
              <div class="flex flex-col gap-4">
                <div class="h-14 w-full bg-gray-200 rounded-lg"></div>
                <div class="flex items-center gap-2">
                  <div class="w-5 h-5 rounded-full bg-gray-200"></div>
                  <div class="h-4 w-28 bg-gray-200 rounded"></div>
                </div>
              </div>
              <div class="flex flex-col gap-4">
                <div class="h-14 w-full bg-gray-200 rounded-lg"></div>
                <div class="flex items-center gap-2">
                  <div class="w-5 h-5 rounded-full bg-gray-200"></div>
                  <div class="h-4 w-28 bg-gray-200 rounded"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Mailing Address Section -->
          <div>
            <div class="h-6 w-36 bg-purple-100 rounded mb-2"></div>
            <div class="h-4 w-80 bg-gray-200 rounded mb-4"></div>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              <div class="h-14 w-full bg-gray-200 rounded-lg"></div>
              <div class="h-14 w-full bg-gray-200 rounded-lg"></div>
              <div class="h-14 w-full bg-gray-200 rounded-lg"></div>
              <div class="h-14 w-full bg-gray-200 rounded-lg"></div>
              <div class="h-14 w-full bg-gray-200 rounded-lg"></div>
            </div>
          </div>

          <!-- Footer Buttons -->
          <div class="flex flex-row items-center justify-end gap-3 sm:gap-4 pt-4 border-t border-ld-border">
            <div class="h-12 w-32 bg-gray-200 rounded-full"></div>
            <div class="h-12 w-36 bg-gray-200 rounded-full"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileSettingsSkeletonComponent {}
